import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "./cta-footer.templates";

const decorator = (Story) => html`
    <div class="ux-t-container-full">
        <ux-iws-sf-page class="ux-iws-sf-page" variant="center-blue">
            ${Story()}
        </ux-iws-sf-page>
    </div>
`;

export default {
    title: "Salesforce/Components/CTA Footer",
    component: "ux-iws-sf-cta-footer",
    render: Template.bind({}),
    decorators: [decorator],
    parameters: {
        layout: "fullscreen",
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const RegisterNow = {
    args: {
        ctaLabel: "Register now",
        text: "You don’t have an account yet?",
    },
};
